var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "2jx2xvdu5b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 20,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.352 2.501H4.04C1.81 2.501 0 4.26 0 6.429v6.284c0 2.17 1.809 3.928 4.04 3.928h9.424a4.242 4.242 0 1 1 5.929-6.066V6.429c0-2.17-1.81-3.928-4.04-3.928z",
    fill: "url(#rzbk1t61ga)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2jx2xvdu5b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#0rqj3vl67c)",
    d: "M0 2.03h19.392v15.083H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "zkiz60dxyd",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 5,
    width: 20,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.941 6.743c0-.52.422-.942.943-.942h13.629a.943.943 0 0 1 0 1.885H2.884a.943.943 0 0 1-.943-.943zm2.908 4.714c0-.52.422-.942.943-.942h.053a.943.943 0 1 1 0 1.885h-.053a.943.943 0 0 1-.943-.943zM20 13.847a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0zm-2.936.375v1.352a.396.396 0 0 1-.398.394.396.396 0 0 1-.397-.394v-1.352h-1.363a.4.4 0 0 1-.36-.396.4.4 0 0 1 .36-.396h1.359v-1.347a.4.4 0 0 1 .4-.357.4.4 0 0 1 .399.357v1.347h1.363a.4.4 0 0 1 .36.396.4.4 0 0 1-.36.396h-1.363z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zkiz60dxyd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dvmw1wwuwe)",
    d: "M1.25 5.764h18.748v12.499H1.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rzbk1t61ga",
    x1: 0,
    y1: 2.501,
    x2: 0,
    y2: 16.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0rqj3vl67c",
    x1: 0,
    y1: 2.03,
    x2: 0,
    y2: 17.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dvmw1wwuwe",
    x1: 1.25,
    y1: 5.764,
    x2: 1.25,
    y2: 18.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddCreditCard);
export default __webpack_public_path__ + "static/media/ic-add-credit-card.1914a315.svg";
export { ForwardRef as ReactComponent };